import { Header, Sidebar } from '@/components/layout';
import { HelpCenterContent, type HelpCenterSection } from '@/features/help-center/HelpCenterContent';

const helpCenterSections = new Set<HelpCenterSection>(['home', 'quickstart', 'videos', 'questions']);

type HelpCenterProps = {
  section?: string;
};

export default function HelpCenter({ section = 'home' }: HelpCenterProps) {
  const normalizedSection = helpCenterSections.has(section as HelpCenterSection)
    ? (section as HelpCenterSection)
    : 'home';

  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header title="Hjálp" />
        <main className="flex-1 overflow-auto">
          <HelpCenterContent section={normalizedSection} />
        </main>
      </div>
    </div>
  );
}
